import { ISideMenuLang } from '../../../types/lang'

export const sideMenuLang: ISideMenuLang = {
	side_menu: {
		affiliate_title: 'Affiliate_ru',
		offer_scope_title: 'Tracking Cap_ru',
		offer_spend_title: 'Offer Spend_ru',
		offer_spend_report_title: 'Report Offer Spend_ru',
		offer_spend_report_by_account_title: 'By Account_ru',
		offer_spend_report_by_offer_title: 'By Offer_ru',
		offer_spend_report_by_offer_scope_title: 'By Offer Scope_ru',
		postback_send_title: 'Send Postback_ru',
		revenue_agency_title: 'Agency_ru',
		revenue_spend_title: 'Spend_ru',
		revenue_spend_report_by_account_title: 'ROI By User_ru',
		revenue_spend_report_by_team_title: 'ROI By Team_ru',
		account_title: 'Accounts_ru',
		role_title: 'Roles_ru',
		job_title: 'Jobs_ru',
		project_title: 'Projects_ru',
		login_title: 'Login_ru',
		logout_title: 'Logout_ru',
	}
}